import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import Text from '../../../../../shared/Text';
import Sort from '../../../../../shared/Sort';

const TableHeader = ({ sortingStatus, changeSort }) => {
  const { t } = useTranslation('reports');

  return (
    <thead>
      <Tr>
        <Th>
          <ThWrapper clickable={true} onClick={() => changeSort('date')}>
            <Sort sortingStatus={sortingStatus} columnName="date" />
            <Text ml="4px" color="black.100" variant="subtitle2">
              {t('questionsTable.head.date')}
            </Text>
          </ThWrapper>
        </Th>
        <Th>
          <Text ml="4px" color="black.100" variant="subtitle2">
            {t('questionsTable.head.name')}
          </Text>
        </Th>
        <Th>
          <ThWrapper clickable={true} onClick={() => changeSort('name')}>
            <Sort sortingStatus={sortingStatus} columnName="name" />
            <Text color="black.100" variant="subtitle2">
              {t('questionsTable.head.contact')}
            </Text>
          </ThWrapper>
        </Th>
        <Th>
          <Text color="black.100" variant="subtitle2">
            {t('questionsTable.head.questions')}
          </Text>
        </Th>
        <Th>
          <ThWrapper clickable={true} onClick={() => changeSort('duration')}>
            <Sort sortingStatus={sortingStatus} columnName="duration" />
            <Text ml="4px" color="black.100" variant="subtitle2">
              {t('questionsTable.head.duration')}
            </Text>
          </ThWrapper>
        </Th>
        <Th>
          <Text color="black.100" variant="subtitle2">
            {t('questionsTable.head.status')}
          </Text>
        </Th>
      </Tr>
    </thead>
  );
};

const Tr = styled.tr`
  &:hover {
    background: white !important;
  }
`;

const Th = styled.th`
  text-align: left;
  padding: 16px 0;

  &:first-child {
    padding-left: 40px;
  }
`;

const ThWrapper = styled.div`
  display: flex;
  align-items: end;

  ${({ clickable }) => clickable && 'cursor: pointer;'}
`;

export default TableHeader;
